var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1243,
    height: 566,
    viewBox: "0 0 1243 566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("line", {
    x1: -391.411,
    y1: -0.167274,
    x2: 362.034,
    y2: 753.277,
    stroke: "url(#paint0_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -318.004,
    y1: -0.167274,
    x2: 435.441,
    y2: 753.277,
    stroke: "url(#paint1_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -244.599,
    y1: -0.167274,
    x2: 508.845,
    y2: 753.277,
    stroke: "url(#paint2_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -171.196,
    y1: -0.167274,
    x2: 582.248,
    y2: 753.277,
    stroke: "url(#paint3_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -97.7898,
    y1: -0.167274,
    x2: 655.655,
    y2: 753.277,
    stroke: "url(#paint4_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -24.385,
    y1: -0.167274,
    x2: 729.059,
    y2: 753.277,
    stroke: "url(#paint5_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.0197,
    y1: -0.167274,
    x2: 802.464,
    y2: 753.277,
    stroke: "url(#paint6_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.426,
    y1: -0.167274,
    x2: 875.871,
    y2: 753.277,
    stroke: "url(#paint7_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.833,
    y1: -0.167274,
    x2: 949.277,
    y2: 753.277,
    stroke: "url(#paint8_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.236,
    y1: -0.167274,
    x2: 1022.68,
    y2: 753.277,
    stroke: "url(#paint9_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.642,
    y1: -0.167274,
    x2: 1096.09,
    y2: 753.277,
    stroke: "url(#paint10_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.049,
    y1: -0.167274,
    x2: 1169.49,
    y2: 753.277,
    stroke: "url(#paint11_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.452,
    y1: -0.167274,
    x2: 1242.9,
    y2: 753.277,
    stroke: "url(#paint12_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.859,
    y1: -0.167274,
    x2: 1316.3,
    y2: 753.277,
    stroke: "url(#paint13_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 636.261,
    y1: -0.167274,
    x2: 1389.71,
    y2: 753.277,
    stroke: "url(#paint14_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 709.668,
    y1: -0.167274,
    x2: 1463.11,
    y2: 753.277,
    stroke: "url(#paint15_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 783.075,
    y1: -0.167274,
    x2: 1536.52,
    y2: 753.277,
    stroke: "url(#paint16_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 856.477,
    y1: -0.167274,
    x2: 1609.92,
    y2: 753.277,
    stroke: "url(#paint17_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 929.884,
    y1: -0.167274,
    x2: 1683.33,
    y2: 753.277,
    stroke: "url(#paint18_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1003.29,
    y1: -0.167274,
    x2: 1756.74,
    y2: 753.277,
    stroke: "url(#paint19_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1076.69,
    y1: -0.167274,
    x2: 1830.14,
    y2: 753.277,
    stroke: "url(#paint20_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1150.1,
    y1: -0.167274,
    x2: 1903.54,
    y2: 753.277,
    stroke: "url(#paint21_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1223.5,
    y1: -0.167274,
    x2: 1976.95,
    y2: 753.277,
    stroke: "url(#paint22_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -405.956,
    y1: 555.609,
    x2: 2048.23,
    y2: 555.609,
    stroke: "url(#paint23_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -405.956,
    y1: 506.183,
    x2: 2048.23,
    y2: 506.183,
    stroke: "url(#paint24_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -405.956,
    y1: 456.756,
    x2: 2048.23,
    y2: 456.756,
    stroke: "url(#paint25_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -405.956,
    y1: 407.33,
    x2: 2048.23,
    y2: 407.33,
    stroke: "url(#paint26_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -405.956,
    y1: 357.904,
    x2: 2048.23,
    y2: 357.904,
    stroke: "url(#paint27_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -405.956,
    y1: 308.478,
    x2: 2048.23,
    y2: 308.478,
    stroke: "url(#paint28_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -405.956,
    y1: 259.052,
    x2: 2048.23,
    y2: 259.052,
    stroke: "url(#paint29_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -405.956,
    y1: 209.625,
    x2: 2048.23,
    y2: 209.625,
    stroke: "url(#paint30_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -405.956,
    y1: 160.199,
    x2: 2048.23,
    y2: 160.199,
    stroke: "url(#paint31_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -405.956,
    y1: 110.773,
    x2: 2048.23,
    y2: 110.773,
    stroke: "url(#paint32_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -405.956,
    y1: 61.3468,
    x2: 2048.23,
    y2: 61.3468,
    stroke: "url(#paint33_radial_1_2344)",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -405.956,
    y1: 11.9205,
    x2: 2048.23,
    y2: 11.9205,
    stroke: "url(#paint34_radial_1_2344)",
    strokeOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-15.3955 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.0112 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.416 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.819 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(278.225 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(351.63 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(425.035 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(498.441 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(571.848 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(645.251 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(718.658 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(792.064 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(865.467 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(938.874 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1012.28 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1085.68 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1159.09 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1232.49 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1305.9 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1379.31 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1452.71 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1526.12 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1599.52 377.262) rotate(45) scale(532.766 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(821.135 556.609) scale(1227.09 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(821.135 507.183) scale(1227.09 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(821.135 457.756) scale(1227.09 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(821.135 408.33) scale(1227.09 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(821.135 358.904) scale(1227.09 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(821.135 309.478) scale(1227.09 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(821.135 260.052) scale(1227.09 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(821.135 210.625) scale(1227.09 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(821.135 161.199) scale(1227.09 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(821.135 111.773) scale(1227.09 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(821.135 62.3468) scale(1227.09 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1_2344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(821.135 12.9205) scale(1227.09 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGrid);
export default __webpack_public_path__ + "static/media/BackgroundGrid.526f733df6f377133cfb0a7ff986443c.svg";
export { ForwardRef as ReactComponent };